export default "__VITE_ASSET__h0$B3CHN__"